// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Icon_wrap__2Wg6P","large":"Icon_large__2TSot"};